// extracted by mini-css-extract-plugin
export default {"hero-background":"technologies-section_hero-background__d8++K","collapse-btn-wrapper":"technologies-section_collapse-btn-wrapper__psCr5"};